/* eslint-disable */
import Pager from './Pager.vue'
import './pagination.styl'

export default {
    name: 'Pagination',
    props: {
        pageSize: {
            type: Number,
            default: 10
        },
        small: Boolean,
        total: Number,
        pageCount: Number,
        currentPage: {
            type: Number,
            default: 1
        },
        layout: {
            default: 'prev, pager, next, total'
        },
        pageSizes: {
            type: Array,
            default() {
                return [25, 50, 100, 250]
            }
        }
    },

    data() {
        return {
            internalCurrentPage: 0,
            internalPageSize: 0
        }
    },

    render(h) {
        let template = <div class="app-pagination" />
        const layout = this.layout || ''
        if (!layout) return
        const TEMPLATE_MAP = {
            prev: <prev />,
            pager: (
                <pager
                    currentPage={this.internalCurrentPage}
                    pageCount={this.internalPageCount}
                    on-change={this.handleCurrentChange}
                />
            ),
            next: <next />,
            slot: <slot />,
            total: <total />,
            sizes: <sizes pageSizes={this.pageSizes} />
        }
        const components = layout.split(',').map(item => item.trim())

        if (this.small) {
            template.data.class += ' app-pagination--small'
        }

        if (!template.children) {
            template.children = []
        }
        components.forEach(compo => {
            template.children.push(TEMPLATE_MAP[compo])
        })

        return template
    },

    components: {
        Prev: {
            render(h) {
                return (
                    <button
                        type="button"
                        aria-label="Prev Page"
                        class={[
                            'btn-prev',
                            { disabled: this.$parent.internalCurrentPage <= 1 }
                        ]}
                        on-click={this.$parent.prev}>
                        <i class="icon icon-paginateleft" />
                    </button>
                )
            }
        },
        Next: {
            render(h) {
                return (
                    <button
                        type="button"
                        aria-label="Next Page"
                        class={[
                            'btn-next',
                            {
                                disabled:
                                    this.$parent.internalCurrentPage ===
                                        this.$parent.internalPageCount ||
                                    this.$parent.internalPageCount === 0
                            }
                        ]}
                        on-click={this.$parent.next}>
                        <i class="icon icon-paginateright" />
                    </button>
                )
            }
        },
        Total: {
            render(h) {
                return typeof this.$parent.total === 'number' ? (
                    <span class="app-pagination__total">
                        {this.$parent.total} Total
                    </span>
                ) : (
                    ''
                )
            }
        },
        Pager,
        Sizes: {
            props: {
                pageSizes: Array
            },

            render(h) {
                return (
                    <span class="app-pagination__sizes">
                        <app-select
                            value={ this.$parent.internalPageSize }
                            size="mini"
                            on-input={ this.handleChange }
                            disabled={ this.$parent.disabled }>
                            {
                                this.pageSizes.map(item =>
                                    <app-option
                                        value={ item }
                                        label={ item } />
                                )
                            }
                        </app-select>
                    </span>
                )
            },

            methods: {
                handleChange(val) {
                    if (val !== this.$parent.internalPageSize) {
                        this.$parent.internalPageSize = val = parseInt(val, 10)
                        this.$parent.userChangePageSize = true
                        this.$parent.$emit('size-change', val)
                    }
                }
            }
        }
    },

    methods: {
        handleCurrentChange(val) {
            this.internalCurrentPage = val
            this.$emit('update:currentPage', val)
            this.$emit('current-change', this.internalCurrentPage)
        },

        prev() {
            const newVal = this.internalCurrentPage - 1
            if (newVal <= 0) { return }
            this.internalCurrentPage = newVal
            this.$emit('update:currentPage', newVal)
            this.$emit('current-change', this.internalCurrentPage)
        },

        next() {
            const newVal = this.internalCurrentPage + 1
            if (newVal > this.internalPageCount) { return }
            this.internalCurrentPage = newVal
            this.$emit('update:currentPage', newVal)
            this.$emit('current-change', this.internalCurrentPage)
        }
    },

    computed: {
        internalPageCount() {
            if (typeof this.total === 'number') {
                return Math.ceil(this.total / this.internalPageSize)
            } else if (typeof this.pageCount === 'number') {
                return this.pageCount
            }
            return null
        }
    },

    watch: {
        currentPage: {
            immediate: true,
            handler(val) {
                this.internalCurrentPage = val
            }
        },

        pageSize: {
            immediate: true,
            handler(val) {
                this.internalPageSize = val
            }
        }
    }
}
